<template lang="html">
  <div id="about-us-page">

    <section class="container oversized-container main-section">
      <div class="row flex-center-xy">
        <div class="col-lg-10 col-info">
          <img class="image-fr" src="public/images/pages/company/phone-circle.jpg">

          <div class="col-s-title">
            <h2 class="title"><span>¿Quiénes somos?</span></h2>
          </div>

          <p>
            SKYCEL empresa 100% mexicana fundada en 2021 pero no por ello sin experiencia ya que sus socios son jugadores de la industria de telecomunicaciones desde el año 2000, y nace de la necesidad de llevar servicios de internet y telefonía móvil a los lugares más apartados de la república mexicana.<br />
            Contamos con la autorización del INSTITUTO FEDERAL DE TELECOMUNICACIONES para brindar servicios de telefonía móvil e internet en la modalidad de prepago y postpago.
          </p>

          <div class="col-s-title">
            <h2 class="title sm"><span>Nuestra misión como empresa</span></h2>
          </div>
          <p>
            Es hacer que México esté mejor conectado y por ende generar igualdad y mejores condiciones de vida en todo el país.
          </p>

          <div class="col-s-title">
            <h2 class="title sm"><span>Nuestra visión</span></h2>
          </div>
          <p>
            Es ser un jugador importante en el ramo de la telefonía móvil, abriendo 200 sucursales en el 2022 en los principales centros comerciales de México y aprovechar nuestra amplia red de distribuidores para llegar a más mexicanos.
          </p>

          <div class="col-s-title">
            <h2 class="title sm"><span>Valores como empresa son</span></h2>
          </div>
          <p>
            <strong class="txt-black">Honestidad:</strong> ofreciendo total transparencia en los consumos de nuestros clientes. Empatía: ofreciendo un excelente servicio a los clientes y siempre poniéndonos en los zapatos del cliente.
          </p>
          <p>
            <strong class="txt-black">Lealtad:</strong> tratando a nuestro equipo de trabajo de una manera respetuosa e impregnando en ellos la esencia de SKYCEL.
          </p>
          <p>
            <strong class="txt-black">Competitividad:</strong> esforzándonos siempre en mejorar y teniendo como meta destacar ante la competencia.
          </p>
          <p>
            <strong class="txt-black">Respeto:</strong> apreciar, reconocer, aceptar y valorar las cualidades de todos los compañeros de trabajo, de nuestros clientes y de nuestros socios comerciales.
          </p>
          <p>
            <strong class="txt-black">Nuestro servicio</strong> funciona en una red de tecnología LTE, contamos con tarifas que serán un diferenciador ante la competencia ya que ofrecemos mucho más que ellos en nuestras tarifas y servicios incluidos, aunado a tecnología en nuestra plataforma.
          </p>

          <div class="col-s-title">
            <h2 class="title sm"><span>SKYCEL ofrecerá los siguientes servicios:</span></h2>
          </div>
          <ul>
            <li>Telefonía móvil en la modalidad de prepago y pospago.</li>
            <li>Internet en casa en la modalidad de prepago.</li>
            <li>Internet con modem portátil en la modalidad de prepago pospago.</li>
            <li>Recargas.</li>
            <li>Venta de celulares nuevos.</li>
            <li>Venta de celulares seminuevos.</li>
            <li>Venta de celulares a crédito (PAYJOY).</li>
            <li>Venta de accesorios para telefonía celular.</li>
          </ul>
          <p>
            Cobertura en el 92% del país por medio de nuestra red y de la red compartida.
          </p>
          <p class="mt-3">
            Skycel es una red de telefonía móvil la cual es distribuida y comercializada por medio de nuestras distintas sucursales a nivel nacional, acompañadas de equipos de telefonía móvil (Smartphone) y accesorios para celular. Somos una OMV (Operadora Móvil Virtual) que tiene su propia red de telefonía, para ofrecer a nuestros clientes una opción competitiva y diferente en el mercado actual en la cual nos enfocamos a servicio de prepago.La RED DE SKYCEL es la más moderna en el mercado, está basada en la red LTE 4.5g de última generación, ofreciendo una gran velocidad en internet, transmisión de voz y datos.
          </p>
          <p>
            Para poder obtener estos beneficios es necesario tener un equipo con tecnología VoLTE o ser compatible con "VozApp" esto ayuda a que la calidad de las llamadas sea superior.
          </p>
        </div>

        <!-- <div class="col-lg-6 col-image mt-3 mt-lg-0">
          <span>
            <img src="public/images/pages/company/phone-circle.jpg">
          </span>
        </div> -->
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
